export default __webpack_public_path__ + "static/media/inbox.2f7403c9.svg";